import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CampanhaROI } from '../../campanha-roi';
import { CampanhaROIKPI, CAMAPANHA_ROI_KPI_RECURSOS, CAMAPANHA_ROI_KPI_RESULTADO, getROIKPI } from '../../campanha-roi-kpi';

@Component({
    selector: 'sgt-campanha-roi-pipeline-widgets',
    templateUrl: './campanha-roi-pipeline-widgets.component.html',
    styleUrls: ['./campanha-roi-pipeline-widgets.component.less']
})
export class CampanhaROIPipelineWidgetsComponent implements OnChanges {
    readonly KPI_RECURSOS = CAMAPANHA_ROI_KPI_RECURSOS;
    readonly KPI_RESULTADO = CAMAPANHA_ROI_KPI_RESULTADO;
    KPI_ROI: CampanhaROIKPI;

    @Input() roi: CampanhaROI;
    @Input() titleColor: string = null;
    @Input() subTitleColor: string = null;

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'roi') {
                this.KPI_ROI = getROIKPI(this.roi?.retornoEfetivo);
            }
        }
    }
}
